module.exports = __webpack_public_path__ + "media/images/mobile/home/close_b-5673e538603075faf4405a4fe160c66c.png";